"use client";
import { FC, useCallback } from "react";
import { getTranslationModule, Translations } from "../../../utils/translations";
import useAnalytics from "@/analytics/useAnalytics";

interface ICallToPrice {
  className: string;
  phone: string;
  translations: Translations;
}

const CallToPrice: FC<ICallToPrice> = ({ phone, className, translations }) => {
  const { sendAnalyticsEvent } = useAnalytics();
  const t = getTranslationModule(translations, "common");
  const onPhoneClick = useCallback(() => {
    sendAnalyticsEvent("asc_click_to_call", {
      comm_phone_number: phone,
      department: "sales",
    });
  }, [phone, sendAnalyticsEvent]);

  return (
    <a title={t("call_for_price")} href={`tel:${phone}`} className={className} onClick={onPhoneClick}>
      {t("call_for_price")}
    </a>
  );
};

export default CallToPrice;
